export const skillsData = [
  {
    id: 1,
    icon: "bx bx-code-alt",
    title: "Frontend",
    items: [
      "JavaScript & TypeScript",
      "React.js & Next.js",
      "HTML5, CSS3 & Tailwind CSS",
      "React Native",
      "Git & GitHub",
    ],
  },
  {
    id: 2,
    icon: "bx bx-server",
    title: "Backend & Cloud",
    items: [
      "Java, Python, Kotlin, C++",
      "Spring Boot, Flask, Django",
      "REST APIs, gRPC, Microservices",
      "AWS (DynamoDB, EKS, SQS, MSK, Aurora, S3)",
      "PostgreSQL, MySQL, MongoDB",
      "Vercel & CI/CD",
    ],
  },
  {
    id: 3,
    icon: "bx bx-brain",
    title: "Machine Learning",
    items: [
      "Python, TensorFlow, Scikit-learn",
      "Real-time object detection & classification pipelines",
      "Predictive modeling & feature engineering",
      "Data visualization & analysis",
      "LLM tooling & AI agent context engineering",
    ],
  },
];
